import ProductsCarousel from './Products'

export default ProductsCarousel
export { ProductsCarousel }
